import type * as React from 'react';

import { type getPageLayoutPreset, PageLayoutPreset } from '@gitbook/hive-core';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';

import type { PageLayoutOptionsProps } from './types';

const layoutOptions: Array<{ type: ReturnType<typeof getPageLayoutPreset>; name: string }> = [
    {
        type: PageLayoutPreset.Docs,
        name: 'Docs',
    },
    {
        type: PageLayoutPreset.Editorial,
        name: 'Editorial',
    },
    {
        type: PageLayoutPreset.Landing,
        name: 'Landing',
    },
    {
        type: 'custom',
        name: 'Custom',
    },
];

const LAYOUTS: PickerItemData<ReturnType<typeof getPageLayoutPreset>>[] = layoutOptions.map(
    (option) => ({
        value: option.type,
        label: option.name,
    })
);

/**
 * Options to configure the layout of a page.
 */
export function PageOptionsLayout(props: PageLayoutOptionsProps): React.ReactElement {
    const { pageOptions, setPageOptionsUpdate } = props;
    return (
        <Picker
            vertical
            value={pageOptions.layoutPreset}
            items={LAYOUTS}
            placeholder="Select a layout"
            onValueChange={(newLayout) => {
                setPageOptionsUpdate({
                    layoutPreset: newLayout,
                });
            }}
        />
    );
}
